/**
 * Labstep
 *
 * @module components/Filter/LogCreatedBy
 * @desc Filter logs by author
 */

import { ICONS } from 'labstep-web/constants/icons';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { User } from 'labstep-web/models/user.model';
import type React from 'react';
import type { FilterLogCreatedByProps } from './types';

const FilterLogCreatedBy: React.FC<FilterLogCreatedByProps> = ({
  authenticatedUserEntity,
  actionComponentProps,
  replace,
  addAnother,
  setParams,
  ...rest
}) => (
  <Modal
    header={`Filter by Organization Member`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text={`Organization Member`}
        {...actionComponentProps}
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <SearchSelect
        entityName={User.entityName}
        params={{
          organization_id:
            authenticatedUserEntity?.userOrganization?.organization
              .guid,
          is_deleted: 'both',
        }}
        onChange={(values) => {
          if (values) {
            setParams({
              author_id: values.guid,
            });
          }
          toggleModal();
        }}
      />
    )}
    {...rest}
  />
);

export default withAuthenticatedUserEntity(FilterLogCreatedBy);
